import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoot from './app/AppRoot';
import { CustomThemeProvider } from './theme/ThemeContext'; // 🔁 Import ThemeProvider

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <CustomThemeProvider> {/* 🔁 Wrap the app in your ThemeProvider */}
      <Router>
        <AppRoot />
      </Router>
    </CustomThemeProvider>
  </React.StrictMode>
);
